import { useEffect, useState } from "react";
import MenuBar from "../MenuBar";
import { apiFetch } from "../api";

import { useI18n } from "../i18n/I18nContext";

/* ============================================================
   THÈMES
   ============================================================ */
const THEMES = {
  dark: {
    page:            { bg: "#0a0a0a",                    color: "#fff" },
    card:            { bg: "rgba(255,255,255,0.03)",      border: "rgba(255,255,255,0.08)" },
    cardHeader:      { bg: "rgba(230,255,62,0.07)",       border: "rgba(230,255,62,0.15)", color: "#e6ff3e" },
    row:             { border: "rgba(255,255,255,0.05)" },
    cellLabel:       { color: "#64748b" },
    cellInput:       { bg: "transparent" },
    input:           { bg: "rgba(255,255,255,0.05)",      border: "rgba(255,255,255,0.1)",  color: "#fff" },
    inputReadonly:   { bg: "rgba(255,255,255,0.02)",      border: "rgba(255,255,255,0.06)", color: "#64748b" },
    defautRow:       { bg: "rgba(255,255,255,0.025)",     border: "rgba(255,255,255,0.05)" },
    defautRowActive: { bg: "rgba(230,255,62,0.05)",       border: "rgba(230,255,62,0.15)" },
    defautLabel:     { color: "#cbd5e1" },
    inputComment:    { bg: "rgba(230,255,62,0.06)",       border: "rgba(230,255,62,0.2)",   color: "#e6ff3e" },
    measureBox:      { bg: "rgba(255,255,255,0.03)",      border: "rgba(255,255,255,0.07)" },
    measureLabel:    { color: "#64748b" },
    measureInput:    { bg: "rgba(255,255,255,0.06)",      border: "rgba(255,255,255,0.1)",  color: "#fff" },
    actionsPanel:    { bg: "rgba(0,0,0,0.2)",             border: "rgba(255,255,255,0.06)" },
    sectionTitle:    { color: "#fff" },
    switchOff:       "rgba(255,255,255,0.1)",
    accent:          "#e6ff3e",
    accentText:      "#000",
    sectionLabel:    { color: "#64748b" },
    toggleBtn:       { bg: "rgba(255,255,255,0.06)",      border: "rgba(255,255,255,0.12)", color: "#fff" },
  },
  light: {
    page:            { bg: "#f1f5f9",                    color: "#0f172a" },
    card:            { bg: "#ffffff",                     border: "#e2e8f0" },
    cardHeader:      { bg: "#f8fafc",                    border: "#e2e8f0",               color: "#475569" },
    row:             { border: "#f1f5f9" },
    cellLabel:       { color: "#94a3b8" },
    cellInput:       { bg: "transparent" },
    input:           { bg: "#f8fafc",                    border: "#e2e8f0",               color: "#0f172a" },
    inputReadonly:   { bg: "#f1f5f9",                    border: "#e2e8f0",               color: "#94a3b8" },
    defautRow:       { bg: "#f8fafc",                    border: "#e2e8f0" },
    defautRowActive: { bg: "#fefce8",                    border: "#fde047" },
    defautLabel:     { color: "#334155" },
    inputComment:    { bg: "#fefce8",                    border: "#fde047",               color: "#713f12" },
    measureBox:      { bg: "#f8fafc",                    border: "#e2e8f0" },
    measureLabel:    { color: "#94a3b8" },
    measureInput:    { bg: "#fff",                       border: "#e2e8f0",               color: "#0f172a" },
    actionsPanel:    { bg: "#f8fafc",                    border: "#e2e8f0" },
    sectionTitle:    { color: "#0f172a" },
    switchOff:       "#e2e8f0",
    accent:          "#1d4ed8",
    accentText:      "#fff",
    sectionLabel:    { color: "#94a3b8" },
    toggleBtn:       { bg: "#fff",                       border: "#e2e8f0",               color: "#334155" },
  },
};

/* ============================================================
   INJECT CSS DYNAMIQUE
   ============================================================ */
function injectStyles(mode) {
  let el = document.getElementById("qsf-dynamic-styles");
  if (!el) { el = document.createElement("style"); el.id = "qsf-dynamic-styles"; document.head.appendChild(el); }

  const lime   = mode === "dark" ? "rgba(230,255,62,0.5)"  : "#1d4ed8";
  const limeBg = mode === "dark" ? "rgba(230,255,62,0.04)" : "rgba(29,78,216,0.04)";
  const limeShadow = mode === "dark" ? "rgba(230,255,62,0.1)" : "rgba(29,78,216,0.1)";
  const btnHoverBg = mode === "dark" ? "#fff"    : "#2563eb";
  const btnHoverShadow = mode === "dark" ? "rgba(230,255,62,0.3)" : "rgba(29,78,216,0.3)";

  el.innerHTML = `
    .qsf-input:focus {
      border-color: ${lime} !important;
      box-shadow: 0 0 0 3px ${limeShadow} !important;
      background: ${limeBg} !important;
    }
    .qsf-measure-input:focus {
      border-color: ${lime} !important;
      box-shadow: 0 0 0 2px ${limeShadow} !important;
    }
    .qsf-measure-box:focus-within {
      border-color: ${lime} !important;
      background: ${limeBg} !important;
    }
    .qsf-comment-input:focus {
      box-shadow: 0 0 0 2px ${limeShadow} !important;
    }
    .qsf-btn-confirm:hover:not(:disabled) {
      background: ${btnHoverBg} !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 8px 24px ${btnHoverShadow} !important;
    }
    .qsf-btn-confirm:active  { transform: scale(0.98) !important; }
    .qsf-btn-confirm:disabled { opacity: 0.5; cursor: not-allowed; }
    .qsf-toggle-btn:hover {
      opacity: 0.8;
      transform: scale(1.05);
    }
    @media (min-width: 640px) {
      .qsf-wrap { padding: 24px 32px 48px !important; }
      .qsf-row  { grid-template-columns: 180px 1fr !important; }
    }
    @media (min-width: 900px) {
      .qsf-wrap { padding: 28px 60px 48px !important; }
      .qsf-form-actions { grid-template-columns: 1fr 300px !important; }
    }
    @media (min-width: 1200px) {
      .qsf-wrap { padding: 32px 140px 48px !important; }
    }
    @media (max-width: 480px) {
      .qsf-row          { grid-template-columns: 1fr !important; }
      .qsf-measure-grid { grid-template-columns: repeat(2, 1fr) !important; }
      .qsf-ep-grid      { grid-template-columns: 1fr 1fr !important; }
    }
    @media (max-width: 900px) {
      .qsf-ep-input {
        font-size: 18px !important;
        min-height: 52px !important;
      }
    }
    .qsf-ep-input {
      touch-action: manipulation;
    }
  `;
}

/* ============================================================
   COMPOSANT PRINCIPAL
   ============================================================ */
export default function QualiteStackForm() {
  const { t, ui } = useI18n();

  const today = new Date().toISOString().split("T")[0];

  // ── Thème persisté dans localStorage ──
  const [mode, setMode] = useState(() => localStorage.getItem("qsf-theme") || "dark");
  const T = THEMES[mode];

  useEffect(() => {
    injectStyles(mode);
    localStorage.setItem("qsf-theme", mode);
  }, [mode]);

  const toggleMode = () => setMode((m) => (m === "dark" ? "light" : "dark"));

  const [operator, setOperator] = useState("");
  const [msg, setMsg]           = useState({ text: "", ok: true });
  const [loading, setLoading]   = useState(false);
  const [photoFile, setPhotoFile]     = useState(null);
const [photoPreview, setPhotoPreview] = useState(null);

const handlePhotoChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;
  setPhotoFile(file);
  setPhotoPreview(URL.createObjectURL(file)); // prévisualisation locale
};

  const [formData, setFormData] = useState({
    Operateur: "", IDStack: "",
    Delamination: false,  DelaminationComment: "",
    Planeite: false,      PlaneiteComment: "",
    DefautSurface: false, DefautSurfaceComment: "",
    AutresDefauts: false, AutresDefautsComment: "",
    Longueur: "", Largeur: "", Masse: "",
    Epaisseur1: "", Epaisseur2: "", Epaisseur3: "",
    Epaisseur4: "", Epaisseur5: "", Epaisseur6: "",
    Date: today,
  });

  useEffect(() => {
    const raw = localStorage.getItem("user");
    if (raw) { try { const u = JSON.parse(raw); setOperator(u.username || ""); } catch {} }
  }, []);

  useEffect(() => {
    if (operator) setFormData((p) => ({ ...p, Operateur: operator }));
  }, [operator]);

  const handleChange = (e) => {
    let { name, value, type } = e.target;
    const isMeasure =
      name.startsWith("Epaisseur") ||
      name === "Longueur" ||
      name === "Largeur" ||
      name === "Masse";
    if (isMeasure) {
      // Tablettes FR : virgule → point ; clavier décimal
      value = String(value).replace(",", ".");
      if (value !== "" && !/^\d*\.?\d*$/.test(value)) return;
    } else if (type === "number" && Number(value) < 0) {
      value = "";
    }
    setFormData((s) => ({ ...s, [name]: value }));
  };

  const toggleSwitch = (flag, comment) =>
    setFormData((prev) => ({
      ...prev,
      [flag]: !prev[flag],
      [comment]: !prev[flag] ? prev[comment] : "",
    }));

  const handleSubmit = async () => {
  setMsg({ text: "", ok: true });
  setLoading(true);
  try {
    // ── Étape 1 : upload photo si sélectionnée ──
    let photoKey = "";
 if (photoFile) {
  const fd = new FormData();
  fd.append("photo", photoFile);
  fd.append("stack_id", formData.IDStack); // ← AJOUTER

  const uploadRes = await apiFetch("/api/qualite/stack/upload-photo", {
    method: "POST",
    body: fd,
  });
      const uploadData = await uploadRes.json();
      if (uploadData.status !== "success") {
        setMsg({ text: "Erreur upload photo : " + uploadData.message, ok: false });
        setLoading(false);
        return;
      }
      photoKey = uploadData.photo_key;
    }

    // ── Étape 2 : envoyer le formulaire avec la clé photo ──
    const r   = await apiFetch("/api/qualite/stack/add", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...formData, PhotoKey: photoKey }),
    });
    const out = await r.json();
    setMsg({ text: out.message || "Erreur", ok: out.status === "success" });

    if (out.status === "success") {
      setPhotoFile(null);
      setPhotoPreview(null);
      setFormData({
        Operateur: operator, IDStack: "",
        Delamination: false,  DelaminationComment: "",
        Planeite: false,      PlaneiteComment: "",
        DefautSurface: false, DefautSurfaceComment: "",
        AutresDefauts: false, AutresDefautsComment: "",
        Longueur: "", Largeur: "", Masse: "",
        Epaisseur1: "", Epaisseur2: "", Epaisseur3: "",
        Epaisseur4: "", Epaisseur5: "", Epaisseur6: "",
        Date: new Date().toISOString().split("T")[0],
      });
    }
  } catch {
    setMsg({ text: "Erreur réseau", ok: false });
  } finally {
    setLoading(false);
  }
};

  const defauts = [
    { label: "Délamination",        flag: "Delamination",  comment: "DelaminationComment"  },
    { label: "Planéité / rectitude", flag: "Planeite",      comment: "PlaneiteComment"       },
    { label: "Défauts de surface",   flag: "DefautSurface", comment: "DefautSurfaceComment"  },
    { label: "Autres défauts",       flag: "AutresDefauts", comment: "AutresDefautsComment"  },
  ];

  /* ── styles inline dépendants du thème ── */
  const s = {
    page:         { minHeight: "100vh", background: T.page.bg, color: T.page.color, fontFamily: "system-ui,-apple-system,Segoe UI,Roboto,sans-serif", transition: "background 0.3s, color 0.3s" },
    wrap:         { padding: "20px 16px 48px" },
    topBar:       { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, marginTop: 8 },
    sectionLeft:  { display: "flex", alignItems: "center", gap: 12 },
    sectionBadge: { background: T.accent, color: T.accentText, fontWeight: 900, fontSize: 11, letterSpacing: "0.08em", textTransform: "uppercase", padding: "4px 12px", borderRadius: 4 },
    sectionTitle: { fontWeight: 900, fontSize: 20, letterSpacing: "0.04em", textTransform: "uppercase", color: T.sectionTitle.color },

    /* Toggle button */
    toggleBtn: {
      display: "flex", alignItems: "center", gap: 8,
      background: T.toggleBtn.bg,
      border: `1px solid ${T.toggleBtn.border}`,
      color: T.toggleBtn.color,
      borderRadius: 10, padding: "8px 14px",
      cursor: "pointer", fontSize: 13, fontWeight: 700,
      fontFamily: "inherit", transition: "all 0.2s",
    },

    card:            { background: T.card.bg, border: `1px solid ${T.card.border}`, borderRadius: 16, overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.15)", transition: "background 0.3s, border-color 0.3s" },
    cardHeader:      { padding: "14px 20px", background: T.cardHeader.bg, borderBottom: `1px solid ${T.cardHeader.border}`, fontWeight: 800, fontSize: 12, letterSpacing: "0.1em", textTransform: "uppercase", color: T.cardHeader.color, transition: "background 0.3s" },
    formAndActions:  { display: "grid", gridTemplateColumns: "1fr" },
    formBody:        { padding: "8px 20px 20px" },

    row:       { display: "grid", gridTemplateColumns: "160px 1fr", alignItems: "center", borderBottom: `1px solid ${T.row.border}`, minHeight: 52 },
    cellLabel: { fontSize: 11, fontWeight: 700, letterSpacing: "0.07em", textTransform: "uppercase", color: T.cellLabel.color, paddingRight: 12, paddingLeft: 4 },
    cellInput: { padding: "8px 0" },

    input:         { width: "100%", height: 38, background: T.input.bg, border: `1px solid ${T.input.border}`, borderRadius: 8, color: T.input.color, fontSize: 13, fontWeight: 600, paddingLeft: 12, outline: "none", fontFamily: "inherit", boxSizing: "border-box", transition: "all 0.2s" },
    inputReadonly: { width: "100%", height: 38, background: T.inputReadonly.bg, border: `1px solid ${T.inputReadonly.border}`, borderRadius: 8, color: T.inputReadonly.color, fontSize: 13, fontWeight: 700, paddingLeft: 12, outline: "none", fontFamily: "inherit", boxSizing: "border-box", letterSpacing: "0.04em" },

    defautsSection:      { marginTop: 20, marginBottom: 4 },
    defautsSectionLabel: { fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: T.sectionLabel.color, marginBottom: 10 },
    defautRow:           { display: "grid", gridTemplateColumns: "1fr 64px", gap: 12, alignItems: "center", padding: "10px 14px", borderRadius: 10, marginBottom: 6, background: T.defautRow.bg, border: `1px solid ${T.defautRow.border}`, transition: "background 0.2s, border-color 0.2s" },
    defautRowActive:     { background: T.defautRowActive.bg, border: `1px solid ${T.defautRowActive.border}` },
    defautLabel:         { fontSize: 13, fontWeight: 600, color: T.defautLabel.color },
    defautComment:       { gridColumn: "1 / -1", marginTop: 6 },
    inputComment:        { width: "100%", background: T.inputComment.bg, border: `1px solid ${T.inputComment.border}`, borderRadius: 8, color: T.inputComment.color, fontSize: 12, fontWeight: 600, padding: "8px 12px", outline: "none", fontFamily: "inherit", boxSizing: "border-box" },

    measuresSection:      { marginTop: 24 },
    measuresSectionLabel: { fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: T.sectionLabel.color, marginBottom: 12 },
    measureGrid:          { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10, marginBottom: 10 },
    measureBox:           { background: T.measureBox.bg, border: `1px solid ${T.measureBox.border}`, borderRadius: 12, padding: "12px 10px 10px", textAlign: "center", transition: "all 0.2s" },
    measureLabel:         { fontSize: 10, fontWeight: 700, letterSpacing: "0.07em", textTransform: "uppercase", color: T.measureLabel.color, marginBottom: 8 },
    measureInput:         { width: "100%", background: T.measureInput.bg, border: `1px solid ${T.measureInput.border}`, borderRadius: 8, color: T.measureInput.color, fontSize: 14, fontWeight: 700, textAlign: "center", padding: "6px 4px", outline: "none", fontFamily: "inherit", boxSizing: "border-box" },

    actionsPanel: { borderTop: `1px solid ${T.actionsPanel.border}`, padding: "20px", display: "flex", flexDirection: "column", gap: 14, background: T.actionsPanel.bg, transition: "background 0.3s" },
    btnConfirm:   { width: "100%", padding: "16px 24px", background: T.accent, color: T.accentText, fontWeight: 900, fontSize: 14, letterSpacing: "0.06em", textTransform: "uppercase", border: "none", borderRadius: 10, cursor: "pointer", fontFamily: "inherit", transition: "all 0.2s" },
    msgSuccess:   { textAlign: "center", fontWeight: 700, fontSize: 13, color: "#4ade80", padding: "10px 14px", background: "rgba(74,222,128,0.08)", border: "1px solid rgba(74,222,128,0.2)", borderRadius: 8 },
    msgError:     { textAlign: "center", fontWeight: 700, fontSize: 13, color: "#f87171", padding: "10px 14px", background: "rgba(248,113,113,0.08)", border: "1px solid rgba(248,113,113,0.2)", borderRadius: 8 },

    switchWrapper: { width: 52, height: 28, position: "relative", cursor: "pointer", flexShrink: 0 },
    slider:        { position: "absolute", inset: 0, borderRadius: 34, transition: "background 0.25s" },
    sliderCircle:  { position: "absolute", width: 20, height: 20, background: "#fff", borderRadius: "50%", left: 4, bottom: 4, transition: "transform 0.25s", boxShadow: "0 2px 4px rgba(0,0,0,0.3)" },


    epImageWrap: { position: "relative", width: "100%", maxHeight: 280, borderRadius: 12, overflow: "hidden", border: `1px solid ${T.measureBox.border}`, marginBottom: 12, userSelect: "none" },
epImage:     { width: "100%", height: "240px", objectFit: "cover", objectPosition: "center", display: "block", borderRadius: 12 },
epPin:       { position: "absolute", transform: "translate(-50%, -50%)", display: "flex", flexDirection: "column", alignItems: "center", gap: 3, zIndex: 10, pointerEvents: "none" },
epPinDot:    { width: 14, height: 14, borderRadius: "50%", background: T.accent, border: "2px solid #000", boxShadow: `0 0 8px ${T.accent}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, fontWeight: 900, color: "#000" },
epPinBox:    { background: "rgba(4,30,46,0.92)", border: `1px solid ${T.accent}`, borderRadius: 6, padding: "4px 8px", textAlign: "center", backdropFilter: "blur(4px)", minWidth: 72 },
epPinLabel:  { fontSize: 9, color: "#94a3b8", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em" },
epPinVal:    { fontSize: 13, fontWeight: 800, color: T.accent },
epGrid:      { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 },
epGridBox:   { background: T.measureBox.bg, border: `1px solid ${T.measureBox.border}`, borderRadius: 12, padding: "12px 10px", textAlign: "center" },
epGridLabel: { fontSize: 11, fontWeight: 700, letterSpacing: "0.04em", textTransform: "uppercase", color: T.measureLabel.color, marginBottom: 8 },
epGridInput: { width: "100%", minHeight: 48, background: T.measureInput.bg, border: `1px solid ${T.measureInput.border}`, borderRadius: 10, color: T.measureInput.color, fontSize: 18, fontWeight: 700, textAlign: "center", padding: "10px 8px", outline: "none", fontFamily: "inherit", boxSizing: "border-box", WebkitAppearance: "none" },

  };

  // Affichage : pins 1..6. Navigation Entrée : gauche → droite (haut puis bas)
  const EP_PINS = [
  { n: 1, label: "entrée haut", top: "22%", left: "9%"  },
  { n: 2, label: "entrée bas", top: "85%", left: "9%"  },
  { n: 3, label: "milieu haut", top: "22%", left: "48%" },
  { n: 4, label: "milieu bas", top: "85%", left: "48%" },
  { n: 5, label: "sortie haut", top: "22%", left: "87%" },
  { n: 6, label: "sortie bas", top: "85%", left: "87%" },
];
  const EP_ENTER_ORDER = [1, 3, 5, 2, 4, 6]; // entrée→milieu→sortie haut, puis bas
  const EP_PIN_BY_N = Object.fromEntries(EP_PINS.map((p) => [p.n, p]));

  const handleEpaisseurKeyDown = (e, n) => {
    if (e.key !== "Enter" && e.key !== "Go" && e.key !== "Next") return;
    e.preventDefault();
    const idx = EP_ENTER_ORDER.indexOf(n);
    if (idx < 0 || idx >= EP_ENTER_ORDER.length - 1) return;
    const next = document.querySelector(`input[name="Epaisseur${EP_ENTER_ORDER[idx + 1]}"]`);
    if (next) {
      next.focus();
      if (typeof next.select === "function") next.select();
    }
  };


  return (
    <div style={s.page}>
      <MenuBar active="qualite" />

      <div style={s.wrap} className="qsf-wrap">

        {/* ── Top bar : titre + toggle ── */}
        <div style={s.topBar}>
          <div style={s.sectionLeft}>
            <span style={s.sectionBadge}>Qualité</span>
            <span style={s.sectionTitle}>Contrôle Stack</span>
          </div>

          {/* 🌙 / ☀️ Toggle */}
          <button
            style={s.toggleBtn}
            className="qsf-toggle-btn"
            onClick={toggleMode}
            title={mode === "dark" ? "Passer en mode clair" : "Passer en mode sombre"}
          >
            <span style={{ fontSize: 16 }}>{mode === "dark" ? "☀️" : "🌙"}</span>
            <span>{mode === "dark" ? "Clair" : "Sombre"}</span>
          </button>
        </div>

        {/* ── Card ── */}
        <div style={s.card}>
          <div style={s.cardHeader}>Paramètres de contrôle</div>

          <div style={s.formAndActions} className="qsf-form-actions">

            {/* ── Formulaire ── */}
            <div style={s.formBody}>

              {/* Infos générales */}
              {[
                { label: "Date", content: (
                  <input type="date" name="Date" value={formData.Date} onChange={handleChange} style={s.input} className="qsf-input" />
                )},
                { label: "Opérateur", content: (
                  <input type="text" readOnly value={operator ? operator.toUpperCase() : "NON CONNECTÉ"} style={s.inputReadonly} />
                )},
                { label: "ID Stack", content: (
                  <input name="IDStack" value={formData.IDStack} onChange={handleChange} style={s.input} className="qsf-input" placeholder="IDS_T…" />
                )},
              ].map(({ label, content }) => (
                <div key={label} style={s.row} className="qsf-row">
                  <div style={s.cellLabel}>{label}</div>
                  <div style={s.cellInput}>{content}</div>
                </div>
              ))}

              {/* Défauts */}
              <div style={s.defautsSection}>
                <div style={s.defautsSectionLabel}>Défauts constatés</div>
                {defauts.map(({ label, flag, comment }) => {
                  const isOn = formData[flag];
                  return (
                    <div key={flag} style={{ ...s.defautRow, ...(isOn ? s.defautRowActive : {}) }}>
                      <div style={s.defautLabel}>{label}</div>
                      <div style={s.switchWrapper} onClick={() => toggleSwitch(flag, comment)}>
                        <div style={{ ...s.slider, background: isOn ? "#4ade80" : T.switchOff }} />
                        <div style={{ ...s.sliderCircle, transform: isOn ? "translateX(24px)" : "translateX(0px)" }} />
                      </div>
                      {isOn && (
                        <div style={s.defautComment}>
                          <input
                            type="text" name={comment}
                            placeholder="Ajouter un commentaire…"
                            value={formData[comment]} onChange={handleChange}
                            style={s.inputComment} className="qsf-comment-input"
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Mesures */}
              <div style={s.measuresSection}>
                <div style={s.measuresSectionLabel}>Mesures dimensionnelles</div>

                {[
                  [{ label: "Longueur", name: "Longueur" }, { label: "Largeur", name: "Largeur" }, { label: "Masse (g)", name: "Masse" }],
                ].map((group, gi) => (
                  <div key={gi} style={s.measureGrid} className="qsf-measure-grid">
                    {group.map(({ label, name }) => (
                      <div key={name} style={s.measureBox} className="qsf-measure-box">
                        <div style={s.measureLabel}>{label}</div>
                        <input
                          name={name} type="text"
                          inputMode="decimal"
                          enterKeyHint="next"
                          autoComplete="off"
                          value={formData[name]} onChange={handleChange}
                          style={{ ...s.measureInput, minHeight: 44, fontSize: 16 }}
                          className="qsf-measure-input"
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>

                {/* ── IMAGE BOIS + SAISIE ÉPAISSEURS (tactile) ── */}
<div style={s.measuresSection}>
  <div style={s.measuresSectionLabel}>Épaisseurs (mm)</div>
  <div style={{ fontSize: 12, color: T.cellLabel.color, marginBottom: 10, fontWeight: 600 }}>
    Sens de saisie : haut gauche → droite (1→3→5), puis bas (2→4→6)
  </div>
  <div style={s.epImageWrap} className="qsf-ep-image-wrap">
    <img src="/images/planche_bois.jpg" alt="Planche bois" style={s.epImage} />
    {EP_PINS.map(({ n, label, top, left }) => {
      const val = formData[`Epaisseur${n}`];
      return (
      <div key={n} style={{ ...s.epPin, top, left }}>
        <div style={s.epPinDot}>{n}</div>
        <div style={s.epPinBox}>
          <div style={s.epPinLabel}>{label}</div>
          <div style={s.epPinVal}>{val !== "" && val != null ? val : "—"}</div>
        </div>
      </div>
      );
    })}
  </div>

  <div style={s.epGrid} className="qsf-ep-grid">
    {EP_ENTER_ORDER.map((n) => {
      const pin = EP_PIN_BY_N[n];
      const isLast = n === EP_ENTER_ORDER[EP_ENTER_ORDER.length - 1];
      return (
        <div key={n} style={s.epGridBox} className="qsf-measure-box">
          <div style={s.epGridLabel}>{n}. {pin?.label}</div>
          <input
            name={`Epaisseur${n}`}
            type="text"
            inputMode="decimal"
            enterKeyHint={isLast ? "done" : "next"}
            autoComplete="off"
            value={formData[`Epaisseur${n}`]}
            onChange={handleChange}
            onKeyDown={(e) => handleEpaisseurKeyDown(e, n)}
            style={s.epGridInput}
            className="qsf-measure-input qsf-ep-input"
            placeholder="mm"
          />
        </div>
      );
    })}
  </div>
</div>



            </div>

              {/* ── Upload Photo ── */}
<div style={{ marginTop: 24 }}>
  <div style={s.measuresSectionLabel}>Photo du stack (optionnel)</div>

  <label style={{
    display: "flex", alignItems: "center", gap: 12,
    padding: "12px 16px",
    background: T.measureBox.bg,
    border: `2px dashed ${T.measureBox.border}`,
    borderRadius: 12, cursor: "pointer",
    transition: "all 0.2s",
  }}>
    <span style={{ fontSize: 24 }}>📷</span>
    <div>
      <div style={{ fontSize: 13, fontWeight: 700, color: T.sectionTitle.color }}>
        {photoFile ? photoFile.name : "Sélectionner une photo"}
      </div>
      <div style={{ fontSize: 11, color: T.cellLabel.color, marginTop: 2 }}>
        JPG, PNG ou WEBP — 5 Mo max
      </div>
    </div>
    <input
  type="file"
  accept="image/*"
  capture="environment"
  onChange={handlePhotoChange}
  style={{ display: "none" }}
/>
  </label>

  {/* Prévisualisation */}
  {photoPreview && (
    <div style={{ marginTop: 10, position: "relative" }}>
      <img
        src={photoPreview}
        alt="Aperçu"
        style={{ width: "100%", maxHeight: 200, objectFit: "cover", borderRadius: 10,
                 border: `1px solid ${T.measureBox.border}` }}
      />
      <button
        onClick={() => { setPhotoFile(null); setPhotoPreview(null); }}
        style={{
          position: "absolute", top: 8, right: 8,
          background: "rgba(0,0,0,0.6)", color: "#fff",
          border: "none", borderRadius: "50%",
          width: 28, height: 28, cursor: "pointer",
          fontSize: 14, fontWeight: 900,
        }}
      >✕</button>
    </div>
  )}
</div>

            {/* ── Actions ── */}
            <div style={s.actionsPanel}>
              <button style={s.btnConfirm} className="qsf-btn-confirm" onClick={handleSubmit} disabled={loading}>
                {loading ? "Envoi en cours…" : "✓ Confirmer & Envoyer"}
              </button>
              {msg.text && (
                <div style={msg.ok ? s.msgSuccess : s.msgError}>
                  {msg.ok ? "✅ " : "❌ "}{msg.text}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
